import React, { Component } from 'react';
import AlbumArt from './AlbumArt';
import customchannels from './images/customchannels.png';

class RecentlyPlayed extends Component {

  render() {
    return (
      <div className="RecentlyPlayed">
      <a href="https://www.customchannels.net" rel="noopener noreferrer" target="_blank"><img id="cc-logo" className="img-responsive PoweredBy" src={ customchannels } alt="Powered by Custom Channels" /></a>
        <h1 id="header">RECENTLY PLAYED</h1>
        { this.props.tracks.map((track, i) => {
          let rowType = (i % 2 === 0 ? '' : 'odd');
          return(
            <div key={ track.played_at } className={ rowType + " Track" }>
              <AlbumArt album={ track.album } />
              <h1>{ track.title }</h1>
              <h2>{ track.artist }</h2>
              <div className="clearfix"></div>
            </div>
          );
        }) }
      </div>
    );
  }
}

export default RecentlyPlayed;



// WEBPACK FOOTER //
// ./src/RecentlyPlayed.js